import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useClipPathId } from "../hooks/use-clip-path-id";

export function EngageFilled(props) {
  const clipPathId = useClipPathId("engage-filled");
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M17.9409 1H7.05909C4.29091 1 2 3.29091 2 6.05909V17.0364C2 19.7091 4.29091 22 7.05909 22H18.0364C20.8045 22 23.0955 19.7091 23.0955 16.9409V6.05909C23 3.29091 20.7091 1 17.9409 1ZM11.2591 15.5091H6.48636C6.00909 15.5091 5.53182 15.1273 5.53182 14.5545C5.53182 13.9818 5.91364 13.6 6.48636 13.6H11.2591C11.7364 13.6 12.2136 13.9818 12.2136 14.5545C12.2136 15.1273 11.8318 15.5091 11.2591 15.5091ZM11.2591 10.3545H6.48636C6.00909 10.3545 5.53182 9.97273 5.53182 9.4C5.53182 8.82727 5.91364 8.44545 6.48636 8.44545H11.2591C11.7364 8.44545 12.2136 8.82727 12.2136 9.4C12.2136 9.97273 11.8318 10.3545 11.2591 10.3545ZM18.4182 15.5091C18.8 15.8909 18.8 16.4636 18.4182 16.8455C18.2273 17.0364 18.0364 17.1318 17.75 17.1318C17.5591 17.1318 17.2727 17.0364 17.0818 16.8455L16.0318 15.7955L14.9818 16.8455C14.7909 17.0364 14.6 17.1318 14.3136 17.1318C14.1227 17.1318 13.8364 17.0364 13.6455 16.8455C13.2636 16.4636 13.2636 15.8909 13.6455 15.5091L14.6955 14.4591L13.6455 13.4091C13.2636 13.0273 13.2636 12.4545 13.6455 12.0727C14.0273 11.6909 14.6 11.6909 14.9818 12.0727L16.0318 13.1227L17.0818 12.0727C17.4636 11.6909 18.0364 11.6909 18.4182 12.0727C18.8 12.4545 18.8 13.0273 18.4182 13.4091L17.3682 14.4591L18.4182 15.5091ZM19.0864 7.49091L16.2227 10.3545C16.0318 10.5455 15.8409 10.6409 15.5545 10.6409C15.2682 10.6409 15.0773 10.5455 14.8864 10.3545L13.1682 8.54091C12.7864 8.15909 12.7864 7.58636 13.1682 7.20455C13.55 6.82273 14.1227 6.82273 14.5045 7.20455L15.5545 8.35L17.75 6.15455C18.1318 5.77273 18.7045 5.77273 19.0864 6.15455C19.4682 6.53636 19.4682 7.10909 19.0864 7.49091Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect
              width={21}
              height={21}
              fill="white"
              transform="translate(2 1)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
